"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOM_STYLE = exports.COLLECTED_FORMS = exports.FORMS_WRITE = exports.FORMS_READ = void 0;

var FormSettingsAccessControl = _interopRequireWildcard(require("settings-ui-sdk/MarketingFreeSettings/accessControl"));

var FORMS_READ = {
  and: [FormSettingsAccessControl.LOAD_ACCESS_CONTROL]
};
exports.FORMS_READ = FORMS_READ;
var FORMS_WRITE = {
  and: [FormSettingsAccessControl.UPDATE_ACCESS_CONTROL]
};
exports.FORMS_WRITE = FORMS_WRITE;
var COLLECTED_FORMS = {
  matchesAllScopes: ['collected-forms-access']
};
exports.COLLECTED_FORMS = COLLECTED_FORMS;
var CUSTOM_STYLE = {
  matchesAllGates: ['Forms:NewPreviewPanel']
};
exports.CUSTOM_STYLE = CUSTOM_STYLE;